import { render, staticRenderFns } from "./EditOtraOrders.vue?vue&type=template&id=949b8c6c"
import script from "./EditOtraOrders.vue?vue&type=script&lang=js"
export * from "./EditOtraOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports